module.exports = __webpack_public_path__ + "img/edit.869a8d57.svg";